import { LayoutDashboard, BarChart3, Star, Users } from "lucide-react";

export const menuItems = [
  { label: "Dashboard", labelKey: "sidebar.menuDashboard", icon: <LayoutDashboard size={20} />, path: "/dashboard" },
  { label: "Admin Panel", labelKey: "sidebar.menuAdmin", icon: <BarChart3 size={20} />, path: "/admin", adminOnly: true },
  { label: "User Analytics", labelKey: "sidebar.menuUsers", icon: <Users size={20} />, path: "/admin/users", adminOnly: true },
  { label: "RLHF Analytics", labelKey: "sidebar.menuRlhf", icon: <Star size={20} />, path: "/admin/rlhf", adminOnly: true },
];